import { createContext, PropsWithChildren, useState } from "react";

interface State {
  isOpen: boolean;
  setOpen: (isOpen: boolean) => void;
}

export const EditModeContext = createContext<State>({
  isOpen: false,
  setOpen: () => {},
});

export const EditModeProvider = ({ children }: PropsWithChildren) => {
  const [isOpen, setOpen] = useState(false);

  return (
    <EditModeContext
      value={{
        isOpen,
        setOpen,
      }}
    >
      {children}
    </EditModeContext>
  );
};
